const routes = {
  login: "/login",
  otpverification: "/otpverification",
  emailverification: "/emailverification",
  signup: "/signup",
  forgotPassword: "/forgotPassword",
  changePassword: "/changePassword",
  home: "/home",
  // myProfile: "/profile",
  service: "/service & support",
  RequestService: "/service & support/RequestService",
  Answers: "/service & support/RequestService",
  TicketPreview: "/service & support/Ticket-Preview",
  privacyPolicy: "/privacy-policy",
  exams: "/exams",
  examSchedule: "/exams/schedule",
  takeExams: "/exams/take-exams",
  gradeCard: "/exams/results",
  gradeCardsDownload: "/exams/grade-cards-download",
  marksBreakdown: "/exams/marks-breakdown",
  serviceFAQ: "/service & support/FAQ",
  allTickets: "/service & support/tickets",
  events: "/events",
  settings: "/profile",
  schedule: "/home/calendar",
  learn: "/learn",
  courseEnrollment: "/course enrollment",
  coreElective: "/course enrollment/core elective",
  enrolledCourses: "/course enrollment/core elective/ enrolled courses",
  feePayment: "/fee payment",
  fees: "/fees",
  thankYouPage: "/acknowledgement",
  socialLinks: "/socialLinks",
  feedback: "/feedback",
  programPathway: "/program-path",
  announcements: "/announcements",
};

export default routes;
